import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CutCopyPasteHelpDialogComponent } from './cut-copy-paste-help-dialog.component';

@NgModule({
  declarations: [
    CutCopyPasteHelpDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  exports: [
    CutCopyPasteHelpDialogComponent
  ]
})
export class CutCopyPasteHelpDialogModule { }
